import { Injectable, isDevMode } from '@angular/core';
import { EMPTY, Subject } from 'rxjs';
import { map } from 'rxjs/internal/operators/map';
import { tap } from 'rxjs/internal/operators/tap';
import { DepartmentsHelpbuttonDaoService } from 'src/app/dao/helpbutton-dao-services/departments-helpbutton-dao-service/departments-helpbutton-dao.service';
import { DepartmentBasic } from 'src/app/models/helpbutton-models/helpbutton-department-basic.model';
import { UserService } from '../../user-service/user.service';
import { UserStorageService } from '../../user-storage-service/user-storage.service';

@Injectable({
  providedIn: 'root'
})
export class DepartmentsHelpbuttonService {

  accessToken = 'HEL';
  refreshDepartmentsListener = new Subject<any>();
  refreshDepartmentListener = new Subject<any>();
  searchDepartmentsListener = new Subject<any>();
  filterDepartmentsListener = new Subject<any>();
  toggleDepartmentsDispositionListener = new Subject<any>();

  constructor(private departmentsDaoService: DepartmentsHelpbuttonDaoService,
              private userStorageService: UserStorageService,
              private userService: UserService) { }

  public getDepartments() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.getDepartments(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          const departments = new Array<DepartmentBasic>();
          o['data']['sectionList'].forEach(
            (item) => {
              const department = new DepartmentBasic();
              Object.assign(department, item);
              departments.push(department);
            }
          );
          return departments;
        })
      );
    }
    return EMPTY;
  }

  public getDepartmentsCounts() {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.getDepartmentsCounts(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID()).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => {
          return {
            availableDepartments: o['data']['counters']['nbAvailables'],
            unavailableDepartments: o['data']['counters']['nbDisabled']
          };
        })
      );
    }
    return EMPTY;
  }

  public getDepartmentInfo(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return  this.departmentsDaoService.getDepartmentInfo(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public addNewDepartment(active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, location, sectionName, sectionImageRaw, askName) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.addNewDepartment(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, location, sectionName, sectionImageRaw, sectionName, askName).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateSection(active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, internalId, location, sectionName, askName) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.updateSection(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), active, centerInternalId, hasPhysicalAssistance, hasVideoconference, onlyVoice, internalId, location, sectionName, askName).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public deleteDepartment(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.deleteDepartment(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public updateImageDepartment(internalId, imageRaw) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.updateImageDepartment(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, imageRaw).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public getGroups(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.getGroups(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public saveGroupSeconds(groupInternalId, seconds) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.saveGroupSeconds(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), groupInternalId, seconds).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public saveStaffGroupRelation(groupInternalId, staffInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.saveStaffGroupRelation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), groupInternalId, staffInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public removeStaffAndGroupRelation(groupInternalId, staffInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.removeStaffAndGroupRelation(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), groupInternalId, staffInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public getDepartmentDevices(internalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.getDepartmentDevices(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public saveDepartmentDevices(internalId, devicesInternalId) {
    if (this.userService.accessGranted(this.accessToken)) {
      return this.departmentsDaoService.saveDepartmentDevices(this.userStorageService.getContext(), this.userStorageService.getLang(), this.userStorageService.getUDID(), internalId, devicesInternalId).pipe(
        tap(o => !isDevMode() || console.dir(o)),
        map(o => o)
      );
    }
    return EMPTY;
  }

  public refreshDepartments() {
    this.refreshDepartmentsListener.next();
  }
  public refreshDepartmentsListen() {
    return this.refreshDepartmentsListener.asObservable();
  }
  public refreshDepartment() {
    this.refreshDepartmentListener.next();
  }
  public refreshDepartmentListen() {
    return this.refreshDepartmentListener.asObservable();
  }
  public searchDepartments(filterKey) {
    this.searchDepartmentsListener.next(filterKey);
  }
  public searchDepartmentsListen() {
    return this.searchDepartmentsListener.asObservable();
  }
  public filterDepartments(opts) {
    this.filterDepartmentsListener.next(opts);
  }
  public filterDepartmentsListen() {
    return this.filterDepartmentsListener.asObservable();
  }
  public toggleDepartmentsDisposition(viewDis) {
    this.toggleDepartmentsDispositionListener.next(viewDis);
  }
  public toggleDepartmentsDispositionListen() {
    return this.toggleDepartmentsDispositionListener.asObservable();
  }
}
